import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerBoggleTranslations } from "./i18n";
import {
  applyVerdict,
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
} from "./progress";
import { emptySolution } from "./solution";
import type { BoggleDefinition, BoggleProgress, BoggleSolution, BoggleSubmission } from "./types";

registerBoggleTranslations(i18n);

/**
 * No `localFeedback`: tracing is enforced as the word is entered, and the dictionary never
 * leaves the server. `applyVerdict` keeps the server's refusals on the player's own words in
 * the saved list, so they stay visible once the attempt is closed (ADR 0057).
 */
export const boggleModule: PuzzleTypeModule<
  BoggleDefinition,
  BoggleSubmission,
  BoggleProgress,
  BoggleSolution
> = {
  key: "boggle",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  applyVerdict,
};
